const autofillSuppressionProps = {
  autoComplete: 'new-password',
  'data-lpignore': 'true',
  'data-1p-ignore': 'true',
  'data-bwignore': 'true',
  'data-protonpass-ignore': 'true',
  'data-form-type': 'other',
};

const domAttributeNames = {
  autoComplete: 'autocomplete',
  autoCorrect: 'autocorrect',
  autoCapitalize: 'autocapitalize',
  inputMode: 'inputmode',
  spellCheck: 'spellcheck',
  enterKeyHint: 'enterkeyhint',
};

export const publicTextInputProps = {
  inputMode: 'text',
  ...autofillSuppressionProps,
  autoCorrect: 'on',
  autoCapitalize: 'sentences',
  spellCheck: 'true',
};

export const publicSearchInputProps = {
  ...publicTextInputProps,
  autoCorrect: 'off',
  autoCapitalize: 'none',
  spellCheck: 'false',
};

export const publicNumericInputProps = {
  inputMode: 'decimal',
  ...autofillSuppressionProps,
  autoCorrect: 'off',
  autoCapitalize: 'none',
  spellCheck: 'false',
};

export const publicMessageInputProps = {
  name: 'chat-message',
  inputMode: 'text',
  autoComplete: 'off',
  'data-lpignore': 'true',
  'data-1p-ignore': 'true',
  'data-bwignore': 'true',
  'data-protonpass-ignore': 'true',
  'data-form-type': 'other',
  'aria-autocomplete': 'none',
  autoCorrect: 'on',
  autoCapitalize: 'sentences',
  spellCheck: 'true',
  enterKeyHint: 'send',
};

export const applyPublicInputAttributes = (input, props) => {
  if (!input || !props) {
    return;
  }

  Object.entries(props).forEach(([name, value]) => {
    if (value == null) {
      return;
    }

    input.setAttribute(domAttributeNames[name] || name, String(value));
  });
};
